interface MapStatsCardsProps {
  arvoresVisiveis: number;
  riscoCritico: number;
  podaRecomendada: number;
  areasVerdes: number;
  ucs: number;
}

export default function MapStatsCards({ arvoresVisiveis, riscoCritico, podaRecomendada, areasVerdes, ucs }: MapStatsCardsProps) {
  const stats = [
    { label: "Árvores visíveis", value: arvoresVisiveis, icon: "ri-plant-line", color: "text-primary-500", bg: "bg-primary-50" },
    { label: "Risco crítico", value: riscoCritico, icon: "ri-close-circle-line", color: "text-danger-500", bg: "bg-danger-50" },
    { label: "Poda recomendada", value: podaRecomendada, icon: "ri-scissors-line", color: "text-warning-500", bg: "bg-warning-50" },
    { label: "Áreas verdes", value: areasVerdes, icon: "ri-landscape-line", color: "text-accent-500", bg: "bg-accent-50" },
    { label: "UCs", value: ucs, icon: "ri-shield-star-line", color: "text-accent-600", bg: "bg-accent-50" },
  ];

  return (
    <div className="flex gap-2">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="bg-white/95 backdrop-blur-sm border border-background-200/70 rounded-card px-3 py-2 shadow-sm flex items-center gap-2.5 whitespace-nowrap"
        >
          <div className={`w-8 h-8 rounded-lg ${stat.bg} flex items-center justify-center shrink-0`}>
            <i className={`${stat.icon} ${stat.color} text-sm`} aria-hidden="true"></i>
          </div>
          <div>
            <p className="text-sm font-bold text-foreground-900 font-heading">{stat.value.toLocaleString()}</p>
            <p className="text-[10px] text-foreground-500">{stat.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
}